const ADD_PRODUIT_ASSOCIES = {
  title: 'Ajouter un produit associé',
  breadcrumb: {
    ajoutProduitAssocie: 'Ajouter un produit associé',
  },
  tab: {
    ref: 'Référence',
    libelle: 'Libellé',
    qte: 'Qte',
    pu: 'PU',
    puTotal: 'PU total',
    tva: 'TVA',
    type: 'Type',
  },
  filtre: {
    ref: 'Référence(s)',
    libelle: 'Libellé(s)',
    type: 'Type(s)',
    tlpe: 'Tlpe',
    honoraire: 'Honoraire',
    societe: 'Société',
  },
  periode: 'Ajout le produit sur la période du :',
  selection: {
    produitAssocieFromProduit: 'Produit(s) déjà associés au produit {reference}',
    noNewProduct: 'Aucun produit ajouté via l\'écran de sélection',
  },
};

export default ADD_PRODUIT_ASSOCIES;
